// https://medium.com/netanelbasal/create-a-typed-version-of-simplechanges-in-angular-451f86593003

export type NgChanges<Component, Props = ExcludeFunctions<Component>> = {
  [Key in keyof Props]: {
    previousValue: Props[Key];
    currentValue: Props[Key];
    firstChange: boolean;
    isFirstChange(): boolean;
  }
}

type ExcludeFunctionPropertyNames<T> = MarkFunctionProperties<T>[keyof T];

type MarkFunctionProperties<Component> = {
  // eslint-disable-next-line  @typescript-eslint/no-unsafe-function-type
  [Key in keyof Component]: Component[Key] extends Function ? never : Key;
}

type ExcludeFunctions<T> = Pick<T, ExcludeFunctionPropertyNames<T>>;
